import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import { calculateLPGSavings, formatTL } from "../lib/savings";

const Range = ({ label, value, onChange, min, max, step, unit, format }) => (
  <div className="range">
    <div className="range__head">
      <label htmlFor={label}>{label}</label>
      <output>{format ? format(value) : `${value} ${unit || ""}`}</output>
    </div>
    <input
      id={label}
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
    />
  </div>
);

const SavingsCalculator = ({ compact = false }) => {
  const [fuel, setFuel] = useState(7.5);
  const [petrol, setPetrol] = useState(52);
  const [lpg, setLpg] = useState(27);
  const [install, setInstall] = useState(28000);
  const [km, setKm] = useState(2000);

  const r = useMemo(
    () => calculateLPGSavings({ fuelConsumption: fuel, fuelPrice: petrol, lpgPrice: lpg, installCost: install, monthlyKm: km }),
    [fuel, petrol, lpg, install, km]
  );

  const pct = Math.max(0, Math.min(100, r.savingPercent));

  return (
    <section className="section" id="hesapla">
      <div className="container">
        {!compact && (
          <SectionHeading
            eyebrow="Tasarruf hesaplayıcı"
            title="LPG size ayda ne kadar kazandırır?"
            text="Aracınızın tüketimini ve aylık kilometrenizi girin; aylık tasarrufu ve montajın kendini ne kadar sürede amorti edeceğini görün."
          />
        )}
        <div className="calculator">
          <div className="card card__body calculator__inputs">
            <Range label="Benzin tüketimi (L/100 km)" value={fuel} onChange={setFuel} min={4} max={20} step={0.1} format={(v) => `${v.toFixed(1)} L`} />
            <Range label="Aylık kilometre" value={km} onChange={setKm} min={300} max={8000} step={100} format={(v) => `${v.toLocaleString("tr-TR")} km`} />
            <Range label="Benzin fiyatı (₺/L)" value={petrol} onChange={setPetrol} min={30} max={90} step={0.5} format={(v) => formatTL(v)} />
            <Range label="LPG fiyatı (₺/L)" value={lpg} onChange={setLpg} min={15} max={50} step={0.5} format={(v) => formatTL(v)} />
            <Range label="Montaj maliyeti" value={install} onChange={setInstall} min={15000} max={60000} step={1000} format={(v) => formatTL(v)} />
          </div>
          <div className="calculator__result">
            <div className="big">
              {formatTL(r.monthlySaving)}
              <small>tahmini aylık tasarruf</small>
            </div>
            <div className="bar" aria-hidden="true">
              <i style={{ width: `${pct}%` }} />
            </div>
            <div className="rows">
              <div><span>Aylık benzin masrafı</span><strong>{formatTL(r.monthlyPetrol)}</strong></div>
              <div><span>Aylık LPG masrafı</span><strong>{formatTL(r.monthlyLpg)}</strong></div>
              <div><span>Tasarruf oranı</span><strong>%{r.savingPercent}</strong></div>
              <div><span>Yıllık tasarruf</span><strong>{formatTL(r.yearlySaving)}</strong></div>
              <div><span>Amortisman süresi</span><strong>{r.paybackMonths ? `${r.paybackMonths} ay` : "—"}</strong></div>
              <div><span>5 yıllık net kazanç</span><strong>{formatTL(r.fiveYearNet)}</strong></div>
            </div>
            <Link to="/iletisim" className="btn btn--accent">
              Aracım için teklif al
            </Link>
            <p className="note">
              LPG'de hacimsel tüketim %18 daha yüksek kabul edilmiştir. Sonuçlar tahminidir; sürüş tarzı ve araca göre değişir.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SavingsCalculator;
